export default __webpack_public_path__ + "static/DisplayHDR-500-4ae89895190b23fcd16f777d66056a60.png";